export default "4d30cc1ae6a418c6.svg"